<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('agencies')">Agencies</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.name }}
      </h1>
    </div>
    <trashed-message v-if="agencyData.deleted_at" class="mb-6" @restore="restore">
      This agency has been deleted.
    </trashed-message>
    <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Name" />

          <text-input v-model="form.code" :error="errors.code" class="pr-6 pb-8 w-full lg:w-1/2" label="Code" />

          <text-input v-model="form.address" :error="errors.address" class="pr-6 pb-8 w-full lg:w-1/2" label="Address" />

          <select-input v-model="form.city" :error="errors.brand" class="pr-6 pb-8 w-full lg:w-1/2" label="City">
            <option v-for="city in cities" :key="city.id" :value="city.id" :selected="city.id === form.city">{{city.name}}</option>
          </select-input>

          <select-input v-model="form.operator" :error="errors.brand" class="pr-6 pb-8 w-full lg:w-1/2" label="Operator">
            <option v-for="operator in operators" :key="operator.id" :value="operator.id" :selected="operator.id === form.operator">{{operator.name}}</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
          <button v-if="!agencyData.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Agency</button>
          <loading-button :loading="sending" class="btn-indigo ml-auto" type="submit">Update Agency</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/AppLayout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  layout: Layout,
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  props: {
    errors: Object,
    agencyData: Object,
    operators: Array,
    cities: Array,
  },
  remember: 'form',
  data() {
    return {
      sending: false,
      form: {
        id: this.agencyData.id,
        name: this.agencyData.name,
        code: this.agencyData.code,
        address: this.agencyData.address,
        city: this.agencyData.city,
        operator: this.agencyData.operator,
      },
    }
  },
  methods: {
    submit() {
      var data = new FormData()
      data.append('name', this.form.name || '')
      data.append('code', this.form.code || '')
      data.append('address', this.form.address || '')
      data.append('city', this.form.city || '')
      data.append('operator', this.form.operator || '')
      data.append('_method', 'put')

      this.$inertia.post(this.route('agencies.update', this.agencyData.id), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {

          }
        },
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this Agency?')) {
        this.$inertia.delete(this.route('agencies.destroy', this.agencyData.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this Agency?')) {
        this.$inertia.put(this.route('agencies.restore', this.agencyData.id))
      }
    },
  },
}
</script>
